module.exports = __webpack_public_path__ + "img/face-hushed.e347db29.svg";